module.exports = __webpack_public_path__ + "img/nodal_domains.81d966de.svg";